"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var i18next_1 = require("i18next");
var index_1 = require("./index");
// methods that require user interaction
var methods = [
    'eth_sendTransaction',
    'eth_signTransaction',
    'personal_sign',
    'eth_sign',
    'eth_signTypedData',
    'eth_signTypedData_v4',
];
function walletConnect(options) {
    var _this = this;
    if (options.version !== 2 || !options.projectId) {
        throw new Error('WalletConnect requires a projectId. Please visit https://cloud.walletconnect.com to get one.');
    }
    var projectId = options.projectId, handleUri = options.handleUri, requiredChains = options.requiredChains, optionalChains = options.optionalChains, qrModalOptions = options.qrModalOptions, additionalOptionalMethods = options.additionalOptionalMethods, dappUrl = options.dappUrl;
    return function () {
        return {
            label: 'WalletConnect',
            getIcon: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icon')); })];
                    case 1: return [2 /*return*/, (_a.sent())["default"]];
                }
            }); }); },
            getInterface: function (_a) {
                var chains = _a.chains, EventEmitter = _a.EventEmitter, appMetadata = _a.appMetadata;
                return __awaiter(_this, void 0, void 0, function () {
                    var _b, ProviderRpcError, ProviderRpcErrorCode, EthereumProvider, _c, Subject, fromEvent, _d, takeUntil, take, getMetaData, requiredChainsParsed, optionalChainsParsed, optionalMethods, connector, emitter, EthProvider;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-common')); })];
                            case 1:
                                _b = _e.sent(), ProviderRpcError = _b.ProviderRpcError, ProviderRpcErrorCode = _b.ProviderRpcErrorCode;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@walletconnect/ethereum-provider')); })];
                            case 2:
                                EthereumProvider = (_e.sent())["default"];
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('rxjs')); })];
                            case 3:
                                _c = _e.sent(), Subject = _c.Subject, fromEvent = _c.fromEvent;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('rxjs/operators')); })];
                            case 4:
                                _d = _e.sent(), takeUntil = _d.takeUntil, take = _d.take;
                                getMetaData = function () {
                                    if (!appMetadata)
                                        return undefined;
                                    var url = dappUrl || appMetadata.explore || '';
                                    !url &&
                                        !url.length &&
                                        console.warn("It is strongly recommended to supply a dappUrl as it is required by some wallets (i.e. MetaMask) to allow connection.");
                                    var wcMetaData = {
                                        name: appMetadata.name,
                                        description: appMetadata.description || '',
                                        url: url,
                                        icons: []
                                    };
                                    if (appMetadata.icon !== undefined && appMetadata.icon.length) {
                                        wcMetaData.icons = [appMetadata.icon];
                                    }
                                    if (appMetadata.logo !== undefined && appMetadata.logo.length) {
                                        wcMetaData.icons = wcMetaData.icons.length
                                            ? __spreadArray(__spreadArray([], wcMetaData.icons, true), [appMetadata.logo], false) : [appMetadata.logo];
                                    }
                                    return wcMetaData;
                                };
                                requiredChainsParsed = Array.isArray(requiredChains) &&
                                    requiredChains.length &&
                                    requiredChains.every(function (num) { return !isNaN(num); })
                                    ? // @ts-ignore
                                        // Required as WC package does not support hex numbers
                                        requiredChains.map(function (chainID) { return parseInt(chainID); })
                                    : [];
                                optionalChainsParsed = Array.isArray(optionalChains) &&
                                    optionalChains.length &&
                                    optionalChains.every(function (num) { return !isNaN(num); })
                                    ? // @ts-ignore
                                        // Required as WC package does not support hex numbers
                                        optionalChains.map(function (chainID) { return parseInt(chainID); })
                                    : chains.map(function (_a) {
                                        var id = _a.id;
                                        return parseInt(id, 16);
                                    });
                                optionalMethods = additionalOptionalMethods && Array.isArray(additionalOptionalMethods)
                                    ? __spreadArray(__spreadArray([], additionalOptionalMethods, true), methods, true) : methods;
                                return [4 /*yield*/, EthereumProvider.init({
                                        projectId: projectId,
                                        chains: requiredChainsParsed,
                                        optionalChains: optionalChainsParsed,
                                        optionalMethods: optionalMethods,
                                        showQrModal: true,
                                        rpcMap: chains
                                            .map(function (_a) {
                                            var id = _a.id, rpcUrl = _a.rpcUrl;
                                            return ({ id: id, rpcUrl: rpcUrl });
                                        })
                                            .reduce(function (rpcMap, _a) {
                                            var id = _a.id, rpcUrl = _a.rpcUrl;
                                            rpcMap[parseInt(id, 16)] = rpcUrl || '';
                                            return rpcMap;
                                        }, {}),
                                        metadata: getMetaData(),
                                        qrModalOptions: qrModalOptions
                                    })];
                            case 5:
                                connector = _e.sent();
                                emitter = new EventEmitter();
                                EthProvider = /** @class */ (function () {
                                    function EthProvider(_a) {
                                        var _this = this;
                                        var connector = _a.connector, chains = _a.chains;
                                        this.emit = emitter.emit.bind(emitter);
                                        this.on = emitter.on.bind(emitter);
                                        this.removeListener = emitter.removeListener.bind(emitter);
                                        this.connector = connector;
                                        this.chains = chains;
                                        this.disconnected$ = new Subject();
                                        // listen for accountsChanged
                                        fromEvent(this.connector, 'accountsChanged', function (payload) { return payload; })
                                            .pipe(takeUntil(this.disconnected$))
                                            .subscribe({
                                            next: function (payload) {
                                                var accounts = Array.isArray(payload) ? payload : [payload];
                                                _this.emit('accountsChanged', accounts);
                                            },
                                            error: console.warn
                                        });
                                        // listen for chainChanged
                                        fromEvent(this.connector, 'chainChanged', function (payload) { return payload; })
                                            .pipe(takeUntil(this.disconnected$))
                                            .subscribe({
                                            next: function (chainId) {
                                                var hexChainId = (0, index_1.isHexString)(chainId)
                                                    ? chainId
                                                    : "0x".concat(chainId.toString(16));
                                                _this.emit('chainChanged', hexChainId);
                                            },
                                            error: console.warn
                                        });
                                        // listen for disconnect event
                                        fromEvent(this.connector, 'session_delete', function (payload) { return payload; })
                                            .pipe(takeUntil(this.disconnected$))
                                            .subscribe({
                                            next: function () {
                                                _this.emit('accountsChanged', []);
                                                _this.disconnected$.next(true);
                                                typeof localStorage !== 'undefined' &&
                                                    localStorage.removeItem('walletconnect');
                                            },
                                            error: console.warn
                                        });
                                        this.disconnect = function () {
                                            if (_this.connector.session)
                                                _this.connector.disconnect();
                                        };
                                        if (options && handleUri) {
                                            // listen for uri event
                                            fromEvent(this.connector, 'display_uri', function (payload) { return payload; })
                                                .pipe(takeUntil(this.disconnected$))
                                                .subscribe(function (uri) { return __awaiter(_this, void 0, void 0, function () {
                                                var _a, error_1;
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0:
                                                            _b.trys.push([0, 3, , 4]);
                                                            _a = handleUri;
                                                            if (!_a) return [3 /*break*/, 2];
                                                            return [4 /*yield*/, handleUri(uri)];
                                                        case 1:
                                                            _a = (_b.sent());
                                                            _b.label = 2;
                                                        case 2:
                                                            _a;
                                                            return [3 /*break*/, 4];
                                                        case 3:
                                                            error_1 = _b.sent();
                                                            throw "An error occurred when handling the URI. Error: ".concat(error_1);
                                                        case 4: return [2 /*return*/];
                                                    }
                                                });
                                            }); });
                                        }
                                        var checkForSession = function () {
                                            var session = _this.connector.session;
                                            if (session) {
                                                _this.emit('accountsChanged', _this.connector.accounts);
                                                _this.emit('chainChanged', _this.connector.chainId);
                                            }
                                        };
                                        checkForSession();
                                        this.request = function (_a) {
                                            var method = _a.method, params = _a.params;
                                            return __awaiter(_this, void 0, void 0, function () {
                                                var chainIdObj;
                                                var _this = this;
                                                return __generator(this, function (_b) {
                                                    if (method === 'eth_chainId') {
                                                        return [2 /*return*/, (0, index_1.isHexString)(this.connector.chainId)
                                                                ? this.connector.chainId
                                                                : "0x".concat(this.connector.chainId.toString(16))];
                                                    }
                                                    if (method === 'eth_requestAccounts') {
                                                        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                                var accounts, chainId, hexChainId;
                                                                var _this = this;
                                                                return __generator(this, function (_a) {
                                                                    switch (_a.label) {
                                                                        case 0:
                                                                            // Subscribe to connection events
                                                                            fromEvent(this.connector, 'connect', function (payload) { return payload; })
                                                                                .pipe(take(1))
                                                                                .subscribe({
                                                                                next: function (_a) {
                                                                                    var chainId = _a.chainId;
                                                                                    _this.emit('accountsChanged', _this.connector.accounts);
                                                                                    var hexChainId = (0, index_1.isHexString)(chainId)
                                                                                        ? chainId
                                                                                        : "0x".concat(chainId.toString(16));
                                                                                    _this.emit('chainChanged', hexChainId);
                                                                                    resolve(_this.connector.accounts);
                                                                                },
                                                                                error: reject
                                                                            });
                                                                            if (!!this.connector.session) return [3 /*break*/, 2];
                                                                            // create new session
                                                                            return [4 /*yield*/, this.connector.connect()["catch"](function (err) {
                                                                                    console.error('err creating new session: ', err);
                                                                                    reject(new ProviderRpcError({
                                                                                        code: 4001,
                                                                                        message: (0, i18next_1.t)('errors.userReject')
                                                                                    }));
                                                                                })];
                                                                        case 1:
                                                                            // create new session
                                                                            _a.sent();
                                                                            return [3 /*break*/, 3];
                                                                        case 2:
                                                                            accounts = this.connector.accounts;
                                                                            chainId = this.connector.chainId;
                                                                            hexChainId = "0x".concat(chainId.toString(16));
                                                                            this.emit('chainChanged', hexChainId);
                                                                            return [2 /*return*/, resolve(accounts)];
                                                                        case 3: return [2 /*return*/];
                                                                    }
                                                                });
                                                            }); })];
                                                    }
                                                    if (method === 'eth_selectAccounts') {
                                                        throw new ProviderRpcError({
                                                            code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
                                                            message: "The Provider does not support the requested method: ".concat(method)
                                                        });
                                                    }
                                                    if (method === 'wallet_switchEthereumChain') {
                                                        if (!params) {
                                                            throw new ProviderRpcError({
                                                                code: ProviderRpcErrorCode.INVALID_PARAMS,
                                                                message: "The Provider requires a chainId to be passed in as an argument"
                                                            });
                                                        }
                                                        chainIdObj = params[0];
                                                        if (!chainIdObj.hasOwnProperty('chainId') ||
                                                            typeof chainIdObj['chainId'] === 'undefined') {
                                                            throw new ProviderRpcError({
                                                                code: ProviderRpcErrorCode.INVALID_PARAMS,
                                                                message: "The Provider requires a chainId to be passed in as an argument"
                                                            });
                                                        }
                                                        return [2 /*return*/, this.connector.request({
                                                                method: 'wallet_switchEthereumChain',
                                                                params: [
                                                                    {
                                                                        chainId: chainIdObj.chainId
                                                                    },
                                                                ]
                                                            })];
                                                    }
                                                    return [2 /*return*/, this.connector.request({
                                                            method: method,
                                                            params: params
                                                        })];
                                                });
                                            });
                                        };
                                    }
                                    return EthProvider;
                                }());
                                return [2 /*return*/, {
                                        provider: new EthProvider({ chains: chains, connector: connector })
                                    }];
                        }
                    });
                });
            }
        };
    };
}
exports["default"] = walletConnect;
